import React, { useEffect } from 'react';
import { IonModal, IonContent, IonIcon } from '@ionic/react';
import { checkmarkCircle } from 'ionicons/icons';
import './SuccessModal.css';

interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const SuccessModal: React.FC<SuccessModalProps> = ({ isOpen, onClose }) => {
  useEffect(() => {
    // eslint-disable-next-line no-console
    console.log('🎉 SuccessModal isOpen changed to:', isOpen);
    if (isOpen) {
      // eslint-disable-next-line no-console
      console.log('✅ Success modal should be visible now!');
    }
  }, [isOpen]);
  
  if (!isOpen) return null;
  
  return (
    <IonModal 
      isOpen={isOpen} 
      onDidDismiss={onClose} 
      className="success-modal"
      backdropDismiss={true}
    >
      <IonContent className="success-content" scrollY={false}>
        <div className="success-modal-wrapper">
          <div className="success-container">
            <div className="success-icon-wrapper">
              <div className="success-icon-circle">
                <IonIcon icon={checkmarkCircle} className="success-icon" />
              </div>
            </div>
            <h2 className="success-title">Welcome to the Inner Circle</h2>
            <p className="success-message">Your key is being prepared.</p>
            <button className="success-button" onClick={onClose}>
              Continue
            </button>
          </div>
        </div>
      </IonContent>
    </IonModal>
  );
};

export default SuccessModal;
